import React from 'react';
import { DatagridBody, useRecordContext } from 'react-admin';
import { TableRow, TableCell } from '@mui/material';

const MyDatagridRow: React.FC<any> = ({ id, children, ...rest }) => {    
    const record = useRecordContext();

    if (!record) return null;

    const colsColor = ['sold_1_hour', 'sold_2_hours', 'sold_4_hours', 'sold_8_hours', 'sold_16_hours'];
    
    const isColor = (source: string) => {
        if (colsColor.includes(source) && record[source] > 0)
            return '#5EA47D';
        return '';
    };

    
    const isCenter = (source: string) => {
        if (typeof record[source] === 'number')
            return 'center';
        return '';
    };    

    return (       
        <TableRow hover={true} {...rest}>
            {React.Children.map(children, (field: any) => {
                // Make sure the field is a valid React element before accessing its props
                if (!React.isValidElement(field)) return null;

                const fieldProps = field.props as { source?: string };
                const source = fieldProps.source || '';

                return (
                    <TableCell 
                        key={`${id}-${source}`}
                        style={{
                            backgroundColor: isColor(source),
                            textAlign: isCenter(source) as any
                        }}
                    >
                        {field}
                    </TableCell>
                );
            })}
        </TableRow>
    );
};

const CustomCellColor: React.FC<any> = (props) => {
    return (
        // 3. XÓA BỎ key={new Date()} - Đây là nguyên nhân chính làm component bị lỗi
        <DatagridBody {...props} row={<MyDatagridRow />} />
    );
};

export default React.memo(CustomCellColor);